import urlParser from 'js-video-url-parser'

export const slugify = (string) => {
  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
}

export const parseVideoURL = (url) => {
  if (url?.includes?.('youtube.com/shorts')) {
    url = url.split('?')[0].replace('shorts/', 'watch?v=')
  }

  const parsed = urlParser.parse(url)

  let parsed_video = {}
  if (parsed?.provider === 'youtube') {
    parsed_video.provider = 'youtube'
    parsed_video.id = parsed.id
  } else if (parsed?.provider === 'vimeo') {
    parsed_video.provider = 'vimeo'
    parsed_video.id = parsed.id
  }

  return parsed_video
}

export const convertVideoUrl = (url) => {
  if (url.includes('youtube.com/shorts')) {
    const regularUrl = convertYoutubeShortToRegularUrl(url)

    return regularUrl
  } else {
    return url
  }
}

const convertYoutubeShortToRegularUrl = (shortUrl) => {
  const regex = /https:\/\/youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/
  const match = shortUrl.match(regex)

  if (match && match[1]) {
    const shortId = match[1]
    return `https://youtube.com/watch?v=${shortId}`
  }

  return shortUrl
}

export const URL_PATTERN = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi

export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/

export const capitalize = (str) => {
  let words = str.replace('-', ' ').split(' ')

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1)
  }

  return words.join(' ')
}

export const possesiveName = (name) => {
  return name.slice(-1) === 's' ? `${name}'` : `${name}'s`
}

export const getDomainFromUrl = (url) => {
  if (!url) {
    return url
  }

  const domain = new URL(url).hostname
  return domain
}
